import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IRegisterFeatureSetPanelStyles {
  root?: IStyle;
  messageBar?: IStyle;
}

export interface IRegisterFeatureSetPanelClassNames {
  root: string;
  messageBar: string;
}

export const registerFeatureSetPanelStylesDefault = (_theme: IH2OTheme): Partial<IRegisterFeatureSetPanelStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  messageBar: { position: 'absolute', zIndex: 1, right: '0px', top: '-81px' },
});
